//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiHelp, mdiChevronUp, mdiChevronDown } from '@mdi/js'
import { computed } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'

export default {
  props: {
    showVerticalDots: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'title',
    },
    tooltip: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const salesByCountries = [
      {
        abbr: 'US',
        amount: '$8,656k',
        country: 'United states of america',
        change: '+25.8%',
        sales: '894k',
        color: 'success',
      },
      {
        abbr: 'UK',
        amount: '$2,415k',
        country: 'United kingdom',
        change: '-6.2%',
        sales: '645k',
        color: 'error',
      },
      {
        abbr: 'IN',
        amount: '$865k',
        country: 'India',
        change: '+12.4%',
        sales: '148k',
        color: 'warning',
      },
      {
        abbr: 'JA',
        amount: '$745k',
        country: 'Japan',
        change: '-11.9%',
        sales: '86k',
        color: 'secondary',
      },
      {
        abbr: 'KO',
        amount: '$45k',
        country: 'Korea',
        change: '+16.2%',
        sales: '42k',
        color: 'error',
      },
    ]
    const dataComputed = computed(() => props.items)
    const titleComputed = computed(() => props.title)

    return {
      salesByCountries,

      dataComputed,
      titleComputed,

      avatarText,

      icons: {
        mdiHelp,
        mdiChevronUp,
        mdiChevronDown,
      },
    }
  },
}
